export const getStyleForSize = (size: number) => {
  if (!size) return {}

  const width = `${size * 100}%`

  return {
    flex: `1 1 ${width}`,
    maxWidth: width,
  }
}

export const getFlexStyles = (flexStyles: any) => {
  const styles: any = {}

  for (const key in flexStyles) {
    if (flexStyles[key]) styles[key] = flexStyles[key]
  }

  return styles
}
